import { render, staticRenderFns } from "./Panel.view.vue?vue&type=template&id=6fb005ff"
import script from "./Panel.view.vue?vue&type=script&lang=js"
export * from "./Panel.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports